var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentTeamActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "#1565D8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "#1565D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "#1565D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.5 19V33H27.5V28H32.5V19H18.5ZM25.5 28H20.5V26H25.5V28ZM30.5 24H20.5V22H30.5V24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 19V28H27.5V33H18.5V19H32.5ZM32.5 17H18.5C17.4 17 16.5 17.9 16.5 19V33C16.5 34.1 17.4 35 18.5 35H28.5L34.5 29V19C34.5 17.9 33.6 17 32.5 17ZM25.5 28H20.5V26H25.5V28ZM30.5 24H20.5V22H30.5V24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTeamActive);
export default __webpack_public_path__ + "static/media/content-team-active.4b449e42df7a27f585b9cfd6cf1003e5.svg";
export { ForwardRef as ReactComponent };